import React, { forwardRef } from "react";
import { Autocomplete, AutocompleteItem } from "@heroui/react";

const LiverSearcher = forwardRef((props, ref) => {
	const [items, setItems] = React.useState([]);
	const [inputValue, setInputValue] = React.useState("");

	return (
		<div ref={ref} {...props}>
			<h2 className={"mb-2"}>会显示选择的主播的最新一场直播的数据</h2>
			<Autocomplete
				items={items}
				inputValue={inputValue}
				onChange={(e) => {
					props.onAnchorSelect(e);
				}}
				onInputChange={(value) => {
					setInputValue(value);
					axios
						.get("/api/search?api=1&type=name&key=" + value)
						.then((response) => {
							setItems(response.data.data ?? []);
						});
				}}
			>
				{(item) => (
					<AutocompleteItem key={item.UID}>
						{item.UName}
					</AutocompleteItem>
				)}
			</Autocomplete>
		</div>
	);
});

export default LiverSearcher;
